import React, { useContext, useEffect } from 'react';
import { ButtonTheme, Size } from '@philips-internal/oswald-ui-constants';
import { classNames } from '@philips-internal/oswald-ui-utils';
import { GlobalActionsStackContext } from '../../../context/global-actions-stack-context.js';
import { isHybridDevice, isPrimaryInputTouch } from '../../../utils/device-capabilities.js';
import { Button } from '../../button/button.js';
function CancelButton(props) {
    return (React.createElement(Button, { className: "c-form__cancel", enabled: !props.submitting, onClick: props.onCancel, size: Size.SMALL, theme: ButtonTheme.SECONDARY, value: props.cancelExpression }));
}
function SaveButton(props) {
    return (React.createElement(Button, { className: "c-form__save", loading: props.submitting, onClick: props.onSubmit, size: Size.SMALL, theme: ButtonTheme.PRIMARY, value: props.saveExpression }));
}
function FormActions(props) {
    const context = useContext(GlobalActionsStackContext);
    const actions = [
        React.createElement(CancelButton, { cancelExpression: props.cancelExpression, key: "form-cancel-action", onCancel: props.onCancel, submitting: props.submitting }),
        React.createElement(SaveButton, { key: "form-save-action", onSubmit: props.onSubmit, saveExpression: props.saveExpression, submitting: props.submitting }),
    ];
    useEffect(() => {
        if (!context) {
            return;
        }
        const popActions = context.pushActions({ actions });
        return () => {
            popActions();
        };
    }, [props.submitting]);
    if (context && isPrimaryInputTouch()) {
        return null;
    }
    const className = classNames({
        'c-form__actions': true,
        'c-form__actions--hide-on-hybrid-mobile': isHybridDevice(),
    });
    return (React.createElement("div", { className: className }, actions));
}
export { FormActions, };
//# sourceMappingURL=form-actions.js.map